import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import ConditionalLabelAndValue from "./ConditionalLabelAndValue";

const OtherDiseasesHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, [
        "otherDiseaseText",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.other.title`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                <ConditionalLabelAndValue
                    {...{
                        switchValue: history.getLatestValueOf("haveOtherDisease"),
                        value: history.getLatestValueOf("otherDiseaseText"),
                        label: "",
                    }}
                />
            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default OtherDiseasesHistory;
